import Button from "@/common/components/Button";
import Modal from "@/common/components/Modal";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { useQueryClient } from "@tanstack/react-query";
import { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAdvanceMaintenanceDirectiveExecutionEntry } from "../../../hooks/useAdvanceMaintenanceDirectiveExecutionEntry";
import { MaintenanceForwardingData } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwarding.type";
import { MaintenanceForwardingDirectiveEntryExecutionEntryData } from "@/features/maintenance/features/workflows/types/forwardings/directiveEntries/executionEntry/executionEntry.type";

interface AdvanceExecutionEntryModalProps {
  forwarding: MaintenanceForwardingData<MaintenanceForwardingDirectiveEntryExecutionEntryData> | undefined
  forwardingUpdatedAt: number
}

const AdvanceExecutionEntryModal = ({
  forwarding,
  forwardingUpdatedAt
}: AdvanceExecutionEntryModalProps) => {
  const { workflowId, forwardingId } = useParams()

  const navigate = useNavigate()

  const [isOpen, setIsOpen] = useState(false);

  const queryClient = useQueryClient();

  const [messages, setMessages] = useState<string[] | boolean>(false);

  const { mutate: advanceExecutionEntry, isPending: advanceExecutionEntryIsPending } =
    useAdvanceMaintenanceDirectiveExecutionEntry({
      directiveEntryId: forwarding?.directive_entry?.id,
      options: {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: ['maintenanceForwarding', forwardingId] })
          navigate(`/maintenance-workflows/${workflowId}/Maintenance::Directive::ExecutionEntry`, { replace: true })
        },
      },
    })

  const isEveryObjectiveCompleted = useMemo(() => {
    return !forwarding?.directive_entry?.objectives?.some((objective) => objective.status !== 'complete')
  }, [forwardingUpdatedAt])

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={(
          <Button
            operationKlassToCheckPermission="Establishment::Maintenance::Directive::ExecutionEntries::Advance"
            disabled={!isEveryObjectiveCompleted}
          >
            Finalizar Manutenção
          </Button>
        )}
        triggerDisabled={!isEveryObjectiveCompleted}
        useCancellableFooter
        confirmButtonClassName="bg-primary-blue rounded-br-lg"
        cancelButtonClassName="rounded-bl-lg"
        onConfirm={() => advanceExecutionEntry()}
        confirmButtonIsLoading={advanceExecutionEntryIsPending}
        title="Finalizar Manutenção?"
        subtitle="Ao confirmar, essa manutenção passará por uma vistoria e caso tudo esteja correto, será finalizada."
        titleClass="text-2xl"
        subtitleClassName="text-base mt-1"
        showClose={false}
      />

      <ModalMessageSimple
        messages={messages}
        setMessages={setMessages}
        isError
      />
    </>
  );
}

export default AdvanceExecutionEntryModal;
